import type {
  TWithdrawalServerResponse,
  TWithdrawalResponse,
  TWithdrawalServer,
  TWithdrawal,
} from '../../store/types';

export const withdrawalItemAdapter = (item: TWithdrawalServer): TWithdrawal => ({
  id: item.id,
  created: item.created,
  updated: item.updated,
  amount: item.amount,
  commission: item.commission,
  currency: item.currency,
  shopId: item.shop_id,
  methodId: item.method_id,
  methodName: item.method_name,
  status: item.status,
  credentials: item.credentials,
  payoutSystem: item.payout_system,
  payoutStatus: item.payout_status,
});

export const withdrawalAdapter = ({ items, count }: TWithdrawalServerResponse): TWithdrawalResponse => ({
  count,
  items: items.map(withdrawalItemAdapter),
});
